import type {
  AccountantStatusMonthParams,
  AccountantStatusPaginatedMonthParams,
  AccountantStatusRepository,
} from "../../domain/repositories/AccountantStatusRepository";
import {
  getAccountantMonthDetailBills,
  getAccountantMonthDetailInvoices,
  getAccountantMonthDetailTransactions,
  getAccountantPerformanceInsights,
  getAccountantStatusSummary,
  getAccountantWorkHistory,
} from "../api/accountantStatusApi";
import {
  accountantPerformanceInsightsDtoToEntity,
  accountantStatusBillsDetailDtoToEntity,
  accountantStatusInvoicesDetailDtoToEntity,
  accountantStatusSummaryDtoToEntity,
  accountantStatusTransactionsDetailDtoToEntity,
  accountantStatusWorkHistoryDtoToEntity,
} from "../mappers/accountantStatusMapper";

export class AccountantStatusRepositoryImpl
  implements AccountantStatusRepository
{
  async getSummary(params?: {
    year?: number;
    month?: number;
    period?: "last_month" | "last_3_months";
  }) {
    const dto = await getAccountantStatusSummary(params);
    return accountantStatusSummaryDtoToEntity(dto);
  }

  async getMonthDetailBills(params: AccountantStatusPaginatedMonthParams) {
    const dto = await getAccountantMonthDetailBills(params);
    return accountantStatusBillsDetailDtoToEntity(dto);
  }

  async getMonthDetailInvoices(params: AccountantStatusPaginatedMonthParams) {
    const dto = await getAccountantMonthDetailInvoices(params);
    return accountantStatusInvoicesDetailDtoToEntity(dto);
  }

  async getMonthDetailTransactions(params: AccountantStatusMonthParams) {
    const dto = await getAccountantMonthDetailTransactions(params);
    return accountantStatusTransactionsDetailDtoToEntity(dto);
  }

  async getWorkHistory() {
    const dtos = await getAccountantWorkHistory();
    return dtos.map(accountantStatusWorkHistoryDtoToEntity);
  }

  async getPerformanceInsights() {
    const dto = await getAccountantPerformanceInsights();
    return accountantPerformanceInsightsDtoToEntity(dto);
  }
}
